module.exports = __webpack_public_path__ + "static/media/user-guide-7.4b5a6adb.png";